import React from 'react';
import ReactDOM from 'react-dom';
import './Imports/index.css';
import Login from './View/Layouts/Login';
import LoginForm from './View/Users/LoginForm';
import reportWebVitals from './reportWebVitals';
import Panel from './View/Layouts/Panel';
import Axios from './Imports/Axios'
import { v4 as uuidv4} from 'uuid'
import * as Storage from './Imports/Storage'
//import * as serviceWorker from './serviceWorker';
//import { subscribeUser } from './subscription';

if (typeof String.prototype.replaceAll === "undefined") {
  // eslint-disable-next-line
  String.prototype.replaceAll = (match, replace) => {
    return this.replace(new RegExp(match, 'g'), () => replace);
  }
}

/* if (window.location.protocol === 'http:') {
 
  window.location.href =
      window.location.href.replace(
              'http:', 'https:');
} */



/* if ('serviceWorker' in navigator) {
  window.addEventListener('load', function() {
    navigator.serviceWorker.register('./service-worker.js').then(function(registration) {
      console.log('ServiceWorker registration successful with scope: ', registration.scope);
    }, function(err) {
      console='ServiceWorker registration failed: ', err);
    });
  });
} */

const start = async () => {
  sessionStorage.setItem("storedRequest", JSON.stringify([]));
  const sessionId = await Storage.get('sessionId') || '0'
  const loggedInUser = await Storage.get('loggedInUser', true) || '0'

  try {
    const requestOptions = {
      url: 'users/check',
      headers: {
        sessionId: sessionId,
        loggedInUser: loggedInUser
      }
    }
    const response = await Axios(requestOptions)
    if(response.data.status === 1000) {
      if(!window.location.pathname || window.location.pathname ==='/') {
        window.location = `/${uuidv4().replace(/-/g, '')}`
      }
      ReactDOM.render(
        <React.StrictMode>
              <Panel />
        </React.StrictMode>,
        document.getElementById('root'), () => {
        }
      );
    }
    else {
      ReactDOM.render(
        <Login />
          
      ,
        document.getElementById('root'), () => {
          ReactDOM.render(<LoginForm/>, document.getElementById('loginForm'));
        }
      );
    }
  } catch (error) {
    console.log(error)
  }
  
}

start()


reportWebVitals()

//serviceWorker.register()

//subscribeUser()
